import React from 'react';

import { CheckoutPortalFormattedMessage } from 'components/Core/CheckoutPrtalForamattedMessage/CheckoutPortalFormattedMessage';
import { getTxnTextBasedOnType, isChangeOrderEnabled } from 'shared/utils';
import { FeatureFlags } from 'types/FeatureFlags';
import { PageVariant, SALE_MAP } from 'types/constants';

interface GetStatusCardTitleProps {
  pageVariant: PageVariant;
  transactionType: string;
  featureFlags?: FeatureFlags;
  estimateStatus?: string | null;
}

export const getStatusCardTitle = ({
  pageVariant,
  transactionType,
  featureFlags,
  estimateStatus,
}: GetStatusCardTitleProps) => {
  if (pageVariant === PageVariant.DEPOSIT_ACCEPTED) {
    return (
      <CheckoutPortalFormattedMessage
        id="ACCEPTED_STATUS_CARD_DEPOSIT_MESSAGE"
        defaultMessage="Deposit paid"
      />
    );
  }

  if (pageVariant === PageVariant.DEPOSIT_DECLINED) {
    return (
      <CheckoutPortalFormattedMessage
        id="DECLINE_DEPOSIT_TITLE_MESSAGE"
        defaultMessage="Estimate and deposit declined"
      />
    );
  }

  if (pageVariant === PageVariant.ESTIMATE_DECLINED) {
    const isChangeOrder = isChangeOrderEnabled(transactionType, featureFlags);
    const { Transaction_text } = getTxnTextBasedOnType(isChangeOrder);
    const Transaction = (
      <CheckoutPortalFormattedMessage
        id={Transaction_text}
        defaultMessage={Transaction_text}
        values={{ transaction: Transaction_text }}
      />
    );

    // Return declined message when estimate is declined
    return (
      <CheckoutPortalFormattedMessage
        id="DECLINED_STATUS_CARD_DECLINE_MESSAGE"
        defaultMessage="{Transaction} declined!"
        values={{ Transaction }}
      />
    );
  }

  if (pageVariant === PageVariant.ESTIMATE_EXPIRED) {
    // Return expired message when estimate is expired - use lowercase "estimate" to match original behavior
    return (
      <CheckoutPortalFormattedMessage
        id="ESTIMATE_EXPIRED"
        defaultMessage="This estimate is not available anymore"
        values={{ transaction: 'estimate' }}
      />
    );
  }
  // Check if status is REJECTED and return declined message
  if (estimateStatus === SALE_MAP.STATUS.REJECTED) {
    // Handle change order transactions specifically for REJECTED status
    if (transactionType === 'change_order') {
      return (
        <CheckoutPortalFormattedMessage
          id="DECLINED_STATUS_CARD_CHANGE_ORDER_MESSAGE"
          defaultMessage="Change order declined!"
        />
      );
    }

    const isChangeOrder = isChangeOrderEnabled(transactionType, featureFlags);
    const { Transaction_text } = getTxnTextBasedOnType(isChangeOrder);
    const Transaction = (
      <CheckoutPortalFormattedMessage
        id={Transaction_text}
        defaultMessage={Transaction_text}
        values={{ transaction: Transaction_text }}
      />
    );

    return (
      <CheckoutPortalFormattedMessage
        id="DECLINED_STATUS_CARD_DECLINE_MESSAGE"
        defaultMessage="{Transaction} declined!"
        values={{ Transaction }}
      />
    );
  }
  // Handle change order transactions specifically
  if (transactionType === 'change_order') {
    return (
      <CheckoutPortalFormattedMessage
        id="ACCEPTED_STATUS_CARD_CHANGE_ORDER_MESSAGE"
        defaultMessage="Change order accepted!"
      />
    );
  }

  const isChangeOrder = isChangeOrderEnabled(transactionType, featureFlags);
  const { Transaction_text } = getTxnTextBasedOnType(isChangeOrder);
  const Transaction = (
    <CheckoutPortalFormattedMessage
      id={Transaction_text}
      defaultMessage={Transaction_text}
      values={{ transaction: Transaction_text }}
    />
  );

  return (
    <CheckoutPortalFormattedMessage
      id="ACCEPTED_STATUS_CARD_ESTIMATE_MESSAGE"
      defaultMessage="{Transaction} accepted!"
      values={{ Transaction }}
    />
  );
};
